/* eslint-disable consistent-return */
import {
  apiNitroPixelPro,
  apiNitroPixelProAecorsoft,
} from '../enviroment/apiNitroPixelPro'
import { loaderService } from './loaderService'

/**
 * Nitro Pixel Pro Service
 * Service for managing administrators and their budgets
 */

//          super-admin

/**
 * Get all administrators with their budget information
 * @returns {Promise<Object>} Response with administrators array
 */
const getAdministradores = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get('/v1/usuarios/administradores')

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting administrators:', error)
    return false
  }
}

/**
 * Update administrator budget
 * @param {Object} body - Request body with usuario_id and presupuesto_asignado
 * @param {number} body.usuario_id - Administrator user ID
 * @param {number} body.presupuesto_asignado - Assigned budget amount
 * @returns {Promise<Object>} Response with success status
 */
const updatePresupuestoAdministrador = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post(
      '/v1/usuarios/administradores',
      body,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error updating administrator budget:', error)
    return false
  }
}

/**
 * Update administrator budget using PUT method
 * @param {Object} body - Request body with presupuesto_asignado
 * @param {number} body.presupuesto_asignado - New budget amount
 * @returns {Promise<Object>} Response with success status
 */
const putPresupuestoAdministrador = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.put(
      '/v1/usuarios/administradores/presupuesto',
      body,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error updating administrator budget (PUT):', error)
    return false
  }
}

/**
 * Update administrator status (enable/disable)
 * @param {Object} body - Request body with usuario_id and estado
 * @param {number} body.usuario_id - Administrator user ID
 * @param {number} body.estado - Status (1 for active, 0 for inactive)
 * @returns {Promise<Object>} Response with success status
 */
const updateEstadoAdministrador = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.patch(
      '/v1/usuarios/administradores',
      body,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error updating administrator status:', error)
    return false
  }
}

/**
 * Get administrator by ID
 * @param {number} usuarioId - Administrator user ID
 * @returns {Promise<Object>} Response with administrator data
 */
const getAdministradorById = async (usuarioId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get(
      `/v1/usuarios/administradores/${usuarioId}`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting administrator by ID:', error)
    return false
  }
}

/**
 * Create new administrator
 * @param {Object} body - Administrator data
 * @returns {Promise<Object>} Response with success status
 */
const createAdministrador = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post(
      '/v1/usuarios/administradores',
      body,
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error creating administrator:', error)
    return false
  }
}

/**
 * Delete administrator
 * @param {number} usuarioId - Administrator user ID
 * @returns {Promise<Object>} Response with success status
 */
const deleteAdministrador = async (usuarioId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.delete(
      `/v1/usuarios/administradores/${usuarioId}`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error deleting administrator:', error)
    return false
  }
}

/**
 * Reset user role (remove administrator role)
 * @param {number} usuarioId - User ID to reset role
 * @returns {Promise<Object>} Response with success status
 */
const resetUserRole = async (usuarioId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.put(
      `/v1/usuarios/reiniciar_rol?usuario_id=${usuarioId}`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error resetting user role:', error)
    return false
  }
}

/**
 * Get all projects with their budget and member information
 * @returns {Promise<Object>} Response with projects array
 */
const getProyectos = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get('/v1/proyectos')

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting projects:', error)
    return false
  }
}

/**
 * Get user projects with budget information
 * @returns {Promise<Object>} Response with user projects array
 */
const getProyectosUsuario = async () => {
  try {
    const response = await apiNitroPixelPro.get('/v1/proyectos/usuarios')

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    console.error('Error getting user projects:', error)
    return false
  }
}

const obtenerInformacionTablas = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get(
      '/v1/proyectos/informacion_tablas',
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting information tables:', error)
    return false
  }
}

/**
 * Create new project
 * @param {Object} body - Project data
 * @param {string} body.nombre_proyecto - Project name
 * @param {number} body.presupuesto_total - Total budget amount
 * @returns {Promise<Object>} Response with success status
 */
const createProyecto = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post('/v1/proyectos', body)

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error creating project:', error)
    return false
  }
}

/**
 * Add member to project
 * @param {Object} body - Member data
 * @param {number} body.usuario_id - User ID to add
 * @param {number} body.proyecto_id - Project ID
 * @returns {Promise<Object>} Response with success status
 */
const agregarMiembroProyecto = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post(
      '/v1/proyectos/agregar_miembro',
      body,
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error adding member to project:', error)
    return false
  }
}

/**
 * Remove member from project
 * @param {number} proyectoId - Project ID
 * @param {number} usuarioId - User ID to remove
 * @returns {Promise<Object>} Response with success status
 */
const eliminarMiembroProyecto = async (proyectoId, usuarioId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.delete(
      `/v1/proyectos/eliminar_miembro?proyecto_id=${proyectoId}&usuario_id=${usuarioId}`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error removing member from project:', error)
    return false
  }
}

/**
 * Get chat history for a specific project
 * @param {number} proyectoId - Project ID
 * @param {number} chatId - Optional chat ID for specific chat
 * @returns {Promise<Object>} Response with chat history array
 */
const getChats = async (proyectoId, chatId = null) => {
  try {
    let url = `/v1/chats?proyecto_id=${proyectoId}`
    if (chatId) {
      url += `&chat_id=${chatId}`
    }

    const response = await apiNitroPixelPro.get(url)

    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    console.error('Error getting chat history:', error)
    return false
  }
}

/**
 * Create a new chat
 * @param {Object} body - Chat data
 * @param {number} body.proyecto_id - Project ID
 * @param {string} body.titulo - Chat title
 * @returns {Promise<Object>} Response with chat data
 */
const createChat = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post('/v1/chats', body)

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error creating chat:', error)
    return false
  }
}

/**
 * Send a message to a chat
 * @param {Object} body - Message data
 * @param {number} body.chat_id - Chat ID
 * @param {string} body.mensaje - Message content
 * @returns {Promise<Object>} Response with message response
 */
const sendMessage = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post('/v1/mensajes', body)

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error sending message:', error)
    return false
  }
}

/**
 * Get messages for a specific chat
 * @param {number} chatId - Chat ID
 * @returns {Promise<Object>} Response with messages array
 */
const getChatMessages = async (chatId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get(`/v1/mensajes?chatId=${chatId}`)

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting chat messages:', error)
    return false
  }
}

/**
 * Get all foundational models
 * @returns {Promise<Object>} Response with foundational models array
 */
const getModelosFundacionales = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get('/v1/modelos_fundacionales')

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting foundational models:', error)
    return false
  }
}

/**
 * Assign administrator to foundational model
 * @param {Object} body - Assignment data
 * @param {number} body.modelo_id - Model ID
 * @param {number} body.usuario_id - User ID to assign
 * @returns {Promise<Object>} Response with success status
 */
const asignarAdministradorModelo = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post(
      '/v1/modelos_fundacionales/asignaciones',
      body,
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error assigning administrator to model:', error)
    return false
  }
}

/**
 * Get all agent instructions
 * @returns {Promise<Object>} Response with agent instructions array
 */
const getInstruccionesAgente = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get('/v1/instrucciones_agente')

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting agent instructions:', error)
    return false
  }
}

/**
 * Update agent instruction
 * @param {Object} body - Update data
 * @param {number} body.id - Instruction ID
 * @param {string} body.nombre_instruccion - Instruction name
 * @param {string} body.contenido_instruccion - Instruction content
 * @returns {Promise<Object>} Response with success status
 */
const actualizarInstruccionAgente = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.put(
      '/v1/instrucciones_agente',
      body,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error updating agent instruction:', error)
    return false
  }
}

/**
 * Assign project to agent instruction
 * @param {Object} body - Assignment data
 * @param {number} body.instruccion_id - Instruction ID
 * @param {number} body.proyecto_id - Project ID
 * @returns {Promise<Object>} Response with success status
 */
const asignarProyectoInstruccion = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post(
      '/v1/instrucciones_agente/asignaciones',
      body,
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error assigning project to instruction:', error)
    return false
  }
}

/**
 * Create new agent instruction
 * @param {Object} body - Instruction data
 * @param {string} body.nombre_instruccion - Instruction name
 * @param {string} body.contenido_instruccion - Instruction content
 * @returns {Promise<Object>} Response with success status
 */
const crearInstruccionAgente = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post(
      '/v1/instrucciones_agente',
      body,
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error creating agent instruction:', error)
    return false
  }
}

/**
 * Update foundational model
 * @param {Object} body - Model update data
 * @param {number} body.id - Model ID
 * @param {string} body.nombre - Model name
 * @param {string} body.descripcion - Model description
 * @param {number} body.costo - Model cost
 * @param {string} body.unidad_costo - Cost unit
 * @param {string} body.configuracion_modelo - Model configuration as JSON string
 * @param {string} body.casos_de_uso - Use cases
 * @param {string} body.tipo - Model type
 * @param {string} body.handler_key - Handler key
 * @returns {Promise<Object>} Response with success status
 */
const actualizarModeloFundamental = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.put(
      '/v1/modelos_fundacionales',
      body,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error updating foundational model:', error)
    return false
  }
}

/**
 * Get available models for projects
 * @returns {Promise<Object>} Response with available models array
 */
const getModelosDisponibles = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get(
      '/v1/proyectos/modelos_disponibles',
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting available models:', error)
    return false
  }
}

/**
 * Assign models to a project
 * @param {Object} body - Assignment data
 * @param {number} body.proyecto_id - Project ID
 * @param {Array<number>} body.modelos_ids - Array of model IDs to assign
 * @returns {Promise<Object>} Response with success status
 */
const asignarModelosProyecto = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post(
      '/v1/proyectos/asignar_modelos',
      body,
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error assigning models to project:', error)
    return false
  }
}

/**
 * Unassign models from a project
 * @param {Object} body - Unassignment data
 * @param {number} body.proyecto_id - Project ID
 * @param {Array<number>} body.modelos_ids - Array of model IDs to unassign
 * @returns {Promise<Object>} Response with success status
 */
const desasignarModelosProyecto = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.delete(
      '/v1/proyectos/desasignar_modelos',
      { data: body },
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error unassigning models from project:', error)
    return false
  }
}

/**
 * Update chat configuration
 * @param {Object} requestData - Chat configuration data
 * @returns {Promise<Object>} Response with success status
 */
const actualizarConfiguracionChats = async (requestData) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.put(
      '/v1/chats/configuracion',
      requestData,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error updating chat configuration:', error)
    return false
  }
}

/**
 * Generate image for a specific chat
 * @param {number} chatId - Chat ID to generate image for
 * @returns {Promise<Object>} Response with generated image data or error details
 */
const generarImagen = async (chatId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get(
      `/v1/generar/imagen?chat_id=${chatId}`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return { success: true, data: response.data }
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error generating image:', error)

    // Manejar errores específicos de la API
    if (error.response) {
      const { status, data } = error.response

      if (status === 402) {
        return {
          success: false,
          error: 'INSUFFICIENT_BALANCE',
          message: data.error || 'No hay saldo suficiente para proceder',
          status,
        }
      }

      return {
        success: false,
        error: 'API_ERROR',
        message: data.error || 'Error en la generación de imagen',
        status,
      }
    }

    return {
      success: false,
      error: 'NETWORK_ERROR',
      message: 'Error de conexión. Por favor, intenta de nuevo.',
      status: 0,
    }
  }
}

/**
 * Generate video for a specific chat
 * @param {number} chatId - Chat ID to generate video for
 * @returns {Promise<Object>} Response with generated video data or error details
 */
const generarVideo = async (chatId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get(
      `/v1/generar/video?chat_id=${chatId}`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return { success: true, data: response.data }
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error generating video:', error)

    // Manejar errores específicos de la API
    if (error.response) {
      const { status, data } = error.response

      if (status === 402) {
        return {
          success: false,
          error: 'INSUFFICIENT_BALANCE',
          message: data.error || 'No hay saldo suficiente para proceder',
          status,
        }
      }

      return {
        success: false,
        error: 'API_ERROR',
        message: data.error || 'Error en la generación de video',
        status,
      }
    }

    return {
      success: false,
      error: 'NETWORK_ERROR',
      message: 'Error de conexión. Por favor, intenta de nuevo.',
      status: 0,
    }
  }
}

/**
 * Upload reference image for a specific chat
 * @param {number} chatId - Chat ID to upload image for
 * @param {File} imageFile - Image file to upload
 * @returns {Promise<Object>} Response with success status and image data
 */
const uploadReferenceImage = async (chatId, imageFile) => {
  try {
    loaderService.show()

    // Crear FormData para enviar el archivo
    const formData = new FormData()
    formData.append('imagen', imageFile)

    const response = await apiNitroPixelPro.post(
      `/v1/imagen-referencia?chat_id=${chatId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error uploading reference image:', error)
    return false
  }
}

/**
 * Delete reference image for a specific chat
 * @param {number} chatId - Chat ID to delete image for
 * @param {string} publicUrl - Public URL of the image to delete
 * @returns {Promise<Object>} Response with success status
 */
const deleteReferenceImage = async (chatId, publicUrl) => {
  try {
    loaderService.show()

    const response = await apiNitroPixelPro.delete('/v1/imagen-referencia', {
      data: {
        public_url: publicUrl,
      },
    })

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error deleting reference image:', error)
    return false
  }
}

/**
 * Validate if a pending URL is ready (has been generated)
 * @param {number} chatId - Chat ID
 * @param {string} uuid - UUID of the pending content
 * @param {string} medio - Type of content: 'imagen' or 'video'
 * @returns {Promise<Object>} Response with URL if ready, or false if still pending
 */
const validarUrlPendiente = async (chatId, uuid, medio = 'imagen') => {
  try {
    const response = await apiNitroPixelPro.get(
      `/v1/generar/validar?chat_id=${chatId}&uuid=${uuid}&medio=${medio}`,
    )

    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    console.error('Error validating pending URL:', error)
    return error.response.data
  }
}

/**
 * Get IAM users information
 * @returns {Promise<Object>} Response with IAM users array
 */
const getIam = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get('/v1/usuarios/iam')

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting IAM users:', error)
    return false
  }
}

/**
 * Get biblioteca information
 * @returns {Promise<Object>} Response with IAM users array
 */
const getBiblioteca = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get('/v1/biblioteca')

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting biblioteca:', error)
    return false
  }
}

/**
 * Get finetune model options for a specific model
 * @param {number} modelId - Model ID to get finetune options for
 * @returns {Promise<Object>} Response with finetune model options array
 */
const getFinetuneModelOptions = async (modelId, proyectoId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get(
      `/v1/finetuning/modelo?id=${modelId}&proyecto_id=${proyectoId}`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting finetune model options:', error)
    return false
  }
}

const getInformacionTablas = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelProAecorsoft.get(
      `/obtener_informacion_tablas`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting finetune model options:', error)
    return false
  }
}

/**
 * Create a new finetune model
 * @param {Object} body - Model data
 * @param {string} body.nombre - Model name
 * @param {string} body.uuid - Model UUID
 * @param {string} body.version - Model version
 * @param {number} body.modelo_fundacional_id - Foundational model ID
 * @returns {Promise<Object>} Response with success status
 */
const createFinetuneModel = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post('/v1/finetuning', body)

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error creating finetune model:', error)
    return false
  }
}

/**
 * Rate a message (calificar mensaje)
 * @param {Object} body - Rating data
 * @param {number} body.mensaje_id - Message ID to rate
 * @param {number} body.calificacion - Rating value (1-5)
 * @returns {Promise<Object>} Response with success status
 */
const calificarMensaje = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post('/v1/biblioteca', body)

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error rating message:', error)
    return false
  }
}

const actualizarCalificionMensaje = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.put('/v1/biblioteca', body)

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error rating message:', error)
    return false
  }
}

/**
 * Get all LoRA models
 * @returns {Promise<Object>} Response with LoRA models array
 */
const getModelosLora = async () => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get('/v1/finetuning')

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting LoRA models:', error)
    return false
  }
}

/**
 * Delete a LoRA model
 * @param {number} modelId - LoRA model ID to delete
 * @returns {Promise<Object>} Response with success status
 */
const deleteLoRAModel = async (modelId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.delete(
      `/v1/finetuning?id=${modelId}`,
    )

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error deleting LoRA model:', error)
    return false
  }
}

/**
 * Update a LoRA model
 * @param {Object} body - Model update data
 * @param {number} body.id - Model ID
 * @param {string} body.nombre - Model name
 * @param {string} body.version - Model version
 * @param {string} body.uuid - Model UUID
 * @param {number} body.modelo_fundacional_id - Foundational model ID
 * @returns {Promise<Object>} Response with success status
 */
const updateLoRAModel = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.put('/v1/finetuning', body)

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error updating LoRA model:', error)
    return false
  }
}

/**
 * Assign a project to a LoRA model
 * @param {Object} body - Assignment data
 * @param {number} body.id - LoRA model ID
 * @param {number} body.proyecto_id - Project ID to assign
 * @returns {Promise<Object>} Response with success status
 */
const asignarProyectoLoRA = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.post(
      '/v1/finetuning/asignar_proyecto',
      body,
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error assigning project to LoRA model:', error)
    return false
  }
}

const deleteProyectoInLOra = async (body) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.delete(
      '/v1/finetuning/desasignar_proyecto',
      {
        data: body,
      },
    )

    if (response.status === 200 || response.status === 201) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error assigning project to LoRA model:', error)
    return false
  }
}

const getConfigChat = async (chatId) => {
  try {
    loaderService.show()
    const response = await apiNitroPixelPro.get(`/v1/chats?chat_id=${chatId}`)

    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    console.error('Error getting chat config:', error)
    return false
  }
}

export {
  getAdministradores,
  updatePresupuestoAdministrador,
  putPresupuestoAdministrador,
  updateEstadoAdministrador,
  getAdministradorById,
  createAdministrador,
  deleteAdministrador,
  resetUserRole,
  getProyectos,
  getProyectosUsuario,
  createProyecto,
  agregarMiembroProyecto,
  eliminarMiembroProyecto,
  getChats,
  createChat,
  sendMessage,
  getChatMessages,
  getModelosFundacionales,
  asignarAdministradorModelo,
  actualizarModeloFundamental,
  getModelosDisponibles,
  asignarModelosProyecto,
  desasignarModelosProyecto,
  getInstruccionesAgente,
  actualizarInstruccionAgente,
  asignarProyectoInstruccion,
  crearInstruccionAgente,
  actualizarConfiguracionChats,
  generarImagen,
  generarVideo,
  uploadReferenceImage,
  deleteReferenceImage,
  validarUrlPendiente,
  getIam,
  getBiblioteca,
  getFinetuneModelOptions,
  createFinetuneModel,
  getInformacionTablas,
  calificarMensaje,
  actualizarCalificionMensaje,
  getModelosLora,
  deleteLoRAModel,
  updateLoRAModel,
  asignarProyectoLoRA,
  deleteProyectoInLOra,
  getConfigChat,
}
